function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.5 17.0833V3.33331C0.5 1.9526 1.61929 0.833313 3 0.833313H7.58333V5.41665C7.58333 6.79736 8.70262 7.91665 10.0833 7.91665H14.6667V17.0833C14.6667 18.464 13.5474 19.5833 12.1667 19.5833H3C1.61929 19.5833 0.5 18.464 0.5 17.0833Z",
  fill: "#738AA5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.83333 4.99998V0.833313L14.6667 6.66665H10.5C9.57952 6.66665 8.83333 5.92045 8.83333 4.99998Z",
  fill: "#738AA5"
});

function SvgQueuesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueuesIcon);
export default __webpack_public_path__ + "static/media/QueuesIcon.e55045f4.svg";
export { ForwardRef as ReactComponent };